import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { User } from '../model';
import { namespace as userNamespace } from '../namespace';

const initialState: {
  data: User;
} = {
  data: {
    cityId: '',
    cityName: '',
    firstName: '',
    userId: '',
    lastName: '',
    middleName: '',
    phone: '',
    source: null,
    roles: [],
  },
};

const userSlice = createSlice({
  name: userNamespace,
  initialState,
  reducers: {
    setUserData: (state, action: PayloadAction<User>) => {
      state.data = action.payload;
    },
    addRole: (state, action: PayloadAction<string>) => {
      if (!state.data.roles.includes(action.payload)) {
        state.data.roles = [...state.data.roles, action.payload];
      }
    },
  },
});

export { userSlice, userNamespace };
